import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import './editable_field.scss';

class EditableField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editMode: props.editMode,
    };

    this.setEditMode = this.setEditMode.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  onSave() {
    this.setState({ editMode: false }, this.props.onSave);
  }

  setEditMode(mode) {
    if (!mode) {
      this.props.onCancel();
    }
    this.setState({ editMode: mode });
  }

  renderEditable() {
    return (
      <div className="editable-field">
        <div className="field">{this.props.editSection}</div>
        <Button className="buttons" color="primary" onClick={this.onSave}>
          Save
        </Button>
        <Button
          className="buttons btn-gray"
          color="outline-secondary"
          onClick={() => this.setEditMode(false)}
        >
          Cancel
        </Button>
      </div>
    );
  }

  renderDisplay() {
    return (
      <div className="editable-field">
        <div className="field">{this.props.children}</div>
        <Button className="buttons" color="link" onClick={() => this.setEditMode(true)}>
          <i className="icon-pencil ml-auto" aria-hidden="true" />
        </Button>
      </div>
    );
  }

  render() {
    return this.state.editMode ? this.renderEditable() : this.renderDisplay();
  }
}

EditableField.propTypes = {
  editSection: PropTypes.node,
  children: PropTypes.node,
  editMode: PropTypes.bool,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
};

export default EditableField;
